// import React from 'react';
// import { Layout, AppBar, LocalesMenuButton } from 'react-admin';
// import MyLogoutButton from './logout_page';
// import MyMenu from './MyMenu';
// import MyNotification from './MyNotification';

// const MyAppBar = () => (
//     <AppBar toolbar={
//         <>
//             <LocalesMenuButton
//                 languages={[
//                     { locale: 'en', name: 'English' },
//                     { locale: 'fr', name: 'Français' },
//                 ]}
//             />
//             <MyLogoutButton />
//             {/* <ToggleThemeButton />
//             <RefreshIconButton /> */}
//         </>
//     } />
// )

// const MyLayout = (props) => <Layout {...props} menu={MyMenu} notification={MyNotification} appBar={MyAppBar} />;

// export default MyLayout;

import React from 'react';
import { Layout ,UserMenu, AppBar,LocalesMenuButton, useSidebarState } from 'react-admin';
import { Box } from '@mui/material';
import { forwardRef } from 'react';
import MyMenu from './MyMenu';
import MenuItem from '@mui/material/MenuItem';
import MyNotification from './MyNotification';
import MyLogoutButton from './logout_page';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Person2Icon from '@mui/icons-material/Person2';
import NotificationsIcon from "@mui/icons-material/Notifications";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, getLocalStorageKey } from "./common/common";
import { styled } from '@mui/material/styles';
import { Link,useNavigate } from 'react-router-dom';




const SettingsButton = forwardRef((props, ref) => {
    const handleClick = () => console.log('fdjdffjhjfhdjfdhf')
    return (
        <MenuItem
            onClick={handleClick}
            ref={ref}
        >
            <AcUnitIcon /> Settings
        </MenuItem>
    );
});

const MyUserMenu = () => {
    const id = getLocalStorageKey("id");

    return(
        <UserMenu>
            <MyLogoutButton />
        </UserMenu>

    )
};

const MyAppBar = () => {
    const navigate = useNavigate();
    return(
    <AppBar 
        userMenu={<MyUserMenu />} 
        toolbar={
            <>
                <LocalesMenuButton
                    languages={[
                        { locale: 'en', name: 'English' },
                        { locale: 'fr', name: 'Français' },
                    ]}
                />
                {/* <ToggleThemeButton />
                <RefreshIconButton /> */}
            </>
        }
    />
    )
};

const drawerWidth = 240;
const closedDrawerWidth = 50;

const MyLayout = (props) => {
    const [sidebarOpen] = useSidebarState(); 

    return (
        <>
            <Layout {...props} menu={MyMenu} notification={MyNotification} />
            <Footer open={sidebarOpen} />
        </>
    );
};

const FooterWrapper = styled('footer', {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    position: 'fixed',
    bottom: 0,
    left: open ? drawerWidth : closedDrawerWidth,
    right: 0,
    height: 48,
    fontSize: 12,
    zIndex: 1,
    padding: '0px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    transition: theme.transitions.create('left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const Footer = ({ open }) => (
    <FooterWrapper open={open}>
        <p>© HOLCIM {new Date().getFullYear()} | App version {process.env.REACT_APP_VERSION}</p>
    </FooterWrapper>
);

export default MyLayout;